import { APP } from '../../redux/constants/app.constants';

export const ADMIN_DEVICE_PAGE = `${APP}/ADMIN_DEVICE_PAGE`;

export const UPDATE_DEVICE = `${ADMIN_DEVICE_PAGE}/UPDATE_DEVICE`;
export const DELETE_DEVICE = `${ADMIN_DEVICE_PAGE}/DELETE_DEVICES`;
export const DEVICE_ERRORS = `${ADMIN_DEVICE_PAGE}/DEVICE_ERROR`;
export const DEVICE_EDIT = `${ADMIN_DEVICE_PAGE}/DEVICE_EDIT`;
export const DEVICE_MANAGE = `${ADMIN_DEVICE_PAGE}/DEVICE_MANAGE`;
export const ENABLE_DEVICE_MODULE = `${ADMIN_DEVICE_PAGE}/ENABLE_DEVICE_MODULE`;
export const RESET_DEVICE_POSITION = `${ADMIN_DEVICE_PAGE}/RESET_DEVICE_POSITION`;
export const GO_TO_JASPER = `${ADMIN_DEVICE_PAGE}/GO_TO_JASPER`;
export const SET_BULK_DEVICES = `${ADMIN_DEVICE_PAGE}/SET_BULK_DEVICES`;
export const SET_BULK_DEVICES_ERRORS = `${ADMIN_DEVICE_PAGE}/SET_BULK_DEVICES_ERRORS`;
export const SHOW_INFO_DIALOG = `${ADMIN_DEVICE_PAGE}/SHOW_INFO_DIALOG`;
export const REFRESH_DEVICE_INFO = `${ADMIN_DEVICE_PAGE}/REFRESH_DEVICE_INFO`;
export const REQUEST_APP_LOGS = `${ADMIN_DEVICE_PAGE}/REQUEST_APP_LOGS`;
export const DISCONNECT = `${ADMIN_DEVICE_PAGE}/DISCONNECT`;
export const ADMIN_DEVICE_BULK_ACTION = `${ADMIN_DEVICE_PAGE}/ADMIN_DEVICE_BULK_ACTION`;
export const DOWNLOAD_CNF = `${ADMIN_DEVICE_PAGE}/DOWNLOAD_CNF`;
export const CUSTOM_CONFIGS_CHANGED = `${ADMIN_DEVICE_PAGE}/CUSTOM_CONFIGS_CHANGED`;
export const IMPORT_V4_DEVICES = `${ADMIN_DEVICE_PAGE}/IMPORT_V4_DEVICES`;
export const V4_IMPORT_ROW_RESULT = `${ADMIN_DEVICE_PAGE}/V4_IMPORT_ROW_RESULT`;
export const V4_IMPORT_DONE = `${ADMIN_DEVICE_PAGE}/V4_IMPORT_DONE`;
export const RESET_V4_IMPORT = `${ADMIN_DEVICE_PAGE}/RESET_V4_IMPORT`;